import React from 'react'
import { Layout, TwoColumns, Sidebar } from 'app/theme/layout'
import HtmlContent from 'app/theme/HtmlContent'
import styles from './CateringFAQPage.module.css'
import { Helmet } from 'react-helmet-async'

export default function CateringFAQPage() {
  const htmlText = `<h1>Catering FAQs</h1>
  <h2>General Info</h2>
  <ul>
    <li><a href="#How_big">What are the dimensions of a food truck?</a></li>
    <li><a href="#What_do_I_provide">I have a food truck coming to my event. What do I need to provide?</a></li>
    <li><a href="#What_food">What kind of food is available?</a></li>
    <li><a href="#Trucks_Avail">What trucks are available for my event?</a></li>
    <li><a href="#More_Than_1_Truck">What if I want more than one food truck at my event?</a></li>
    <li><a href="#Parking">Where can food trucks park?</a></li>
    <li><a href="#pay_to_park">Do food trucks pay to park?</a></li>
  </ul>
  <h2>Public Events</h2>
  <ul>
    <li><a href="#Licenses_Permits_COI">Do all Roaming Hunger vendors have health permits and insurance?</a></li>
    <li><a href="#What_is_Public_Event">What is a Roaming Hunger public event?</a></li>
    <li><a href="#Get_Started_Public_Event">How to book food trucks for events or get a food truck to come to your
        business.</a></li>
    <li><a href="#Donate_or_fee">Can I expect a food truck to pay a fee or donate a portion of their sales?</a></li>
    <li><a href="#What_is_a_a_oeminimum">What are guaranteed "minimums" for food trucks?</a></li>
    <li><a href="#Guarantee_for_Public_Event">How can I guarantee that a food truck will show up?</a></li>
    <li><a href="#Public_Event_Cost">Is there a fee to be connected to food trucks for my public event?</a></li>
  </ul>
  <h2>Private Events</h2>
  <ul>
    <li><a href="#What_is_Private_Catering">What is private food truck catering?
      </a></li>
    <li><a href="#Catering_Get_Started">How can I get started booking a truck for private catering?</a></li>
    <li><a href="#Payment">How does payment work?</a></li>
    <li><a href="#Budget">How much does a food truck cost?</a></li>
    <li><a href="#Lower_Cost">Why won't the cost go any lower, even with fewer people?</a></li>
    <li><a href="#How_long_to_decide">How long do I have to decide which food truck I would like to book?</a></li>
    <li><a href="#More_or_Less_People">What if I have a different number of people show up on the day of the event than I
        expected?</a></li>
    <li><a href="#Cancel">What if I need to cancel or reschedule my event?</a></li>
    <li><a href="#Occasions">What types of occasions can food trucks cater?</a></li>
  </ul>
  <div class="faq_full">
    <br>
    <h3 id="How_big">What are the dimensions of a food truck?</h3>
    <p>Truck dimensions vary, but they are typically 16' to 24' long, 10' high and 8' wide. Food carts and trailers are
      significantly smaller.</p>
    <br>
    <h3 id="What_do_I_provide">I have a food truck coming to my event. What do I need to provide?</h3>
    <p>Food trucks are self-contained mobile kitchens and only need access to a restroom for their staff during the event.
      If your event is longer than a few hours, providing power is a good idea, but not necessary. If your event runs
      overnight, power is strongly advised.

      Disposable serving wares and a trash can are usually provided by the truck. Extra trash cans are strongly advised.
      If you would like a place for your guests to sit and eat, you will need to provide tables and chairs. Otherwise,
      trucks just show up, serve your guests delicious food, and drive away with all the mess leaving your event location
      clean and tidy - it's super convenient!</p>
    <br>
    <h3 id="What_food">What kind of food is available?</h3>
    <p>In most major cities, there is a wide variety of cuisine that food trucks serve. Also, trucks are flexible! Most
      are able to offer at least one vegetarian, vegan, gluten-free or allergy-free option in their customized menu for
      you. If you have a specific request, be sure to ask.</p>
    <br>
    <h3 id="Trucks_Avail">What trucks are available for my event?</h3>
    <p>We have a network of over 23,000 food trucks nationwide, and our expert catering and event agents can usually find a
      food truck that meets your specific requests.</p>
    <br>
    <h3 id="More_Than_1_Truck">What if I want more than one food truck at my event?</h3>
    <p>Food trucks are typically able to serve 60 - 100 guests per hour. Depending on the number of guests, time, and
      menu, the optimal number of trucks for an event can depend. We suggest speaking with one of our catering and event
      experts to determine what is best for you. If you would like to book more trucks than Roaming Hunger recommends, no
      problem! Just make sure to budget accordingly to meet each truck's minimum.</p>
    <br>
    <h3 id="Parking">Where can food trucks park?</h3>
    <p>Food truck parking can be tricky. Some cities have specific restrictions on where food trucks can serve, so be sure
      to check with your local government (typically the Department of Public Works). If you would like the truck park on
      public property like a street, you can, 1) park a car in the space until the truck arrives, or 2) contact the city
      to have a space reserved (additional fees may apply). If the truck is parking on private property, you simply need
      permission from the property owner. </p>
    <br>
    <h3 id="pay_to_park">Do food trucks pay to park?</h3>
    <p>On the street, food trucks are required to abide by all posted parking signs, including paid meters. Sometimes,
      food truck parking fees are administered by organized lots or businesses.</p>
    <br>
    <h3 id="Licenses_Permits_COI">Do all Roaming Hunger vendors have health permits and insurance?</h3>
    <p>Roaming Hunger requires all the foods trucks we work with for events and catering to have a health permit and
      insurance. We keep vendor certificates of insurance on file and will be able to provide you with a copy if needed.
      Roaming Hunger does not provide any additional permits, including permits required by larger venues and events
      (example: street fairs, community events, festivals). Please check with the appropriate venues and government
      agencies to ensure you have acquired all necessary permits.</p>
    <br>
    <h3 id="What_is_Public_Event">What is a Roaming Hunger public event?</h3>
    <p>A public event is any situation where the event attendees will be purchasing their food directly from the truck(s).
      This is different than a catering event, in which the host (or company) usually pays for the food truck to come out
      and serve food to guests or employees.</p>
    <br>
    <h3 id="Get_Started_Public_Event">How to book food trucks for events or get a food truck to come to your
      business.</h3>
    <p>If you have an event where <a href="https://roaminghunger.com/food-truck-catering/">attendees are paying for their
        own food click here</a>. Click "Book Now" and check the section that says "Attendees will pay for themselves."
      This will direct you to the appropriate event agent at Roaming Hunger.</p>
    <br>
    <h3 id="Donate_or_fee">Can I expect a food truck to pay a fee or donate a portion of their sales?</h3>
    <p>It doesn't hurt to ask. Every truck will need to make that determination for themselves based on the potential
      profitability of your event. We recommend being up front with that information in the details section of your event
      submission.</p>
    <br>
    <h3 id="What_is_a_a_oeminimum">What are guaranteed "minimums" for food trucks?</h3>
    <p>For events open to the public, some food trucks require minimums. A minimum for a food truck is the amount of money
      they would need to make for it to be worth it for them to come to your event. If they do less than that amount in
      sales, the organizer is responsible for covering the difference. Typical minimums are $500 for a savory truck and
      $250 for a dessert truck. Although, the minimum amount depends on the truck. Guaranteeing a minimum up front will
      make it much easier for you to find a great truck willing to commit to your event.</p>
    <br>
    <h3 id="Guarantee_for_Public_Event">How can I guarantee that a food truck will show up?</h3>
    <p>There are two ways to guarantee that a food truck will show up at your event. 1) book the truck for private
      catering &amp; prepay meals 2) provide the truck with a minimum guaranteed amount of meals.
      <br>
      <br>If you would like Roaming Hunger to facilitate this level of service, we do charge food truck vendor fees. Our
      involvement comes with the benefit of contracts for both the event organizer and the participating truck(s) for
      greater peace of mind. Please email us at <a href="mailto:events@roaminghunger.com">events@roaminghunger.com</a>
      with your event details.</p>
    <br>
    <h3 id="Public_Event_Cost">Is there a fee to be connected to food trucks for my public event?</h3>
    <p>Roaming Hunger has created a system that connects you to potential food trucks for free. Just submit your event
      details, and trucks that are interested in participating will get in contact with you directly to coordinate.</p>
    <br>
    <h3 id="What_is_Private_Catering">What is private food truck catering?
    </h3>
    <p>Food truck catering is the same as any other catering service. It is usually for a private event and paid for by
      the host. Roaming Hunger has a team of catering experts that will provide availability, menus, booking and
      coordination of anything you might need for your event. The greatest part is that you do not need to worry about
      payment the day of the event. All you have to do is enjoy delicious food!</p>
    <br>
    <h3 id="Catering_Get_Started">How can I get started booking a truck for private catering?</h3>
    <p>If your event is hosted or you are paying for everyone's food, click here to book <a
        href="https://roaminghunger.com/food-truck-catering/">food truck catering</a>. Check the section that says "The host
      will pay for everyone." This will direct you to a personal catering agent at Roaming Hunger.</p>
    <br>
    <h3 id="Payment">How does payment work?</h3>
    <p>When you're ready to book, payment needs to be remitted to Roaming Hunger to confirm your truck. Roaming Hunger
      then holds the money until after your event to guarantee you get fantastic day-of service.</p>
    <br>
    <h3 id="Budget">How much does a food truck cost?</h3>
    <p>Pricing varies greatly depending on the truck, desired menu, number of guests, travel time, length of service, and
      service date. Use our handy <a href="https://roaminghunger.com/food-truck-catering/#calculator">budget calculator</a>
      as a starting point to explore the cost of a food truck for your event.
    <br>
    <h3 id="Lower_Cost">Why won't the cost go any lower, even with fewer people?</h3>
    <p>You'll notice that our <a href="https://roaminghunger.com/food-truck-catering/#calculator">budget calculator</a>
      won't go below a certain price no matter how few guests you plan to serve. This number is an estimate of a food
      truck's absolute minimum required cost to serve any catered event in your area. If you have a small party, try
      adding dessert, drinks and snacks or a longer service time to get the most for your money.</p>
    <br>
    <h3 id="How_long_to_decide">How long do I have to decide which food truck I would like to book?</h3>
    <p>Trucks that have submitted for your event usually save the date as a courtesy. There are occasions when trucks will
      receive multiple opportunities on the same day and time, therefore we cannot hold or guarantee your booking. A
      trucks is considered booked when the deposit is paid and catering agreements are signed. We encourage you to make a
      decision quickly to secure your favorite truck(s).</p>
    <br>
    <h3 id="More_or_Less_People">What if I have a different number of people show up on the day of the event
      than I expected?</h3>
    <p>Food trucks will come prepared to serve the number of guests agreed upon. Roaming Hunger cannot guarantee that the
      truck will come prepared to serve any additional guests. In most cases, trucks will bring 10% more product to
      provide any additional servings as needed. However, we advise speaking with your Account Manager beforehand to
      confirm this. If, at your direction, the truck does serve extra guests, payment for those additional meals will be
      due upon completion of the event. The cost of each additional meal will be specified in advance at the time of
      booking.</p>
    <br>
    <h3 id="Cancel">What if I need to cancel or reschedule my event?</h3>
    <p>If you need to reschedule your event, we will make our best effort to work with the confirmed food truck to
      reschedule your event date or time. If we are not able to accommodate your request, you will be subject to the
      cancellation policy as outlined in the catering agreement.</p>
    <br>
    <h3 id="Occasions">What types of occasions can food trucks cater?</h3>
    <p>Food trucks can cater any type of event. Here are a few of the main types of food truck occasions:
      <br><a href="https://roaminghunger.com/food-truck-catering/corporate-catering/">Corporate Catering</a><br><br><a
        href="https://roaminghunger.com/food-truck-catering/film-production-catering/">Production / On Set
        Catering</a><br><br><a
        href="https://roaminghunger.com/food-truck-catering/conference-and-event-catering/">Professional
        Events</a><br><br><a href="https://roaminghunger.com/food-truck-catering/food-truck-wedding/">Wedding
        Catering</a><br><br><a href="https://roaminghunger.com/food-truck-catering/campus-catering/">Food Trucks on
        Campus</a><br><br><a href="https://roaminghunger.com/food-truck-catering/large-event-food-concessions/">Large-Scale
        Events &amp; Multi City Event Series</a><br><br><a href="
  https://roaminghunger.com/food-truck-catering/local-community-concessions/">Community Events</a><br><br><a href="
  https://roaminghunger.com/food-truck-catering/party-catering/">Private Parties</a><br>
    </p>
  </div>`
  return (
    <Layout className="container py-10">
      <Helmet>
        <title>
          Roaming Hunger - Follow the Street Food Movement™ - Food Truck and
          Food Cart Locator - Roaming Hunger
        </title>
        <meta
          name="description"
          content="Roaming Hunger is the hub for all things street food. Find and follow food trucks and food carts in your city live!"
        />
        <meta
          name="og:title"
          content="Roaming Hunger - Follow the Street Food Movement™ - Food Truck and Food Cart Locator"
        />
      </Helmet>
      <TwoColumns sidebar={<Sidebar />}>
        <div className={styles.catering_faq_container}>
          <HtmlContent content={htmlText} />
        </div>
      </TwoColumns>
    </Layout>
  )
}
